import React from 'react';
import WpItem from 'wp/item';
import './styles.scss';

function MainQuienesSomos() {
    return (
        <section id='quienes-somos'>
            <div className='wrapper-central'>
                <WpItem type='page' slug='quienes-somos' />
            </div>
        </section>
    )
};

export default MainQuienesSomos;